<template>
    <div id="linkit-kavoniuksen-julkaisuihin">
      <section id="parallax-1" class="hero is-large">
          <div class="hero-body"  style="padding: 6rem 6rem;">
              <div class="container">
              <div class="columns">
                  <div class="column is-12 has-text-justified">
                    <h1 class="title">LINKIT KAVONIUKSEN JULKAISUIHIN</h1>
                    <div class="linkit">
<h2>TODISTEET TOTUUDESTA JA LINKKEJÄ MATERIAALIIN</h2>
<h3>VIRKAMAFIA.fi</h3>
<p><a target="_blank" rel="noopener" href="https://virkamafia.fi">https://virkamafia.fi</a></p>
<p>Oikeusvaltion kulissi on kaatunut. Virkamafia.fi-sivut ovat suurin koskaan tehty törkeän rikollisuuden paljastus juristipuoluejohtajan todisteilla ja samalla Kavoniuksen syyttömyyden todisteiden julkistus.</p>
<p>Virkamafia.fi-sivun oikean laidan linkeistä pääsette sukeltamaan Suomen suurimman koskaan tehdyn rikollisuuden paljastuksen oikeisiin totuuksiin ja todisteisiin, joita virkamafian lavastajat, tutkinnantappajat ja virkamafiarikollisuuden avulla rikoshyötynsä hankkinut kultti, petosverkostot ja valtamedia ovat peitelleet.</p>
<h3>PROTONDRIVE</h3>
<p>Todisteita löydätte 260 GT ProtonDrivesta:</p>
<p><a target="_blank" rel="noopener" href="https://drive.proton.me/urls/YBD9YB0Z10#dTHOmqnFzFHR">https://drive.proton.me/urls/YBD9YB0Z10#dTHOmqnFzFHR</a></p>
<h3>TIKTOK</h3>
<p><a target="_blank" rel="noopener" href="https://www.tiktok.com/@jaanakavonius1">https://www.tiktok.com/@jaanakavonius1</a></p>
<p>TikTokissa Jaana Kavonius on julkaissut JAKSOT 1-204 eli 204 videota, jossa on oikeaa tietoa Kavoniuksen paljastamasta virkamafia-verkostosta, sen avulla valtavia petoshyötyjä hankkivista asianajajista, LähiTapiolan,  LP Vahinkosaneerauksen, Jani Jormanaisen ja muiden rikoskumppanien laajasta petosverkostosta, Juha Ruohosen johtamasta kultista ja sen rahavirroista ja Kavoniukseen juristipuoluejohtajana ja totuudenkertojana kohdistetusta väkivallasta, rikolliseksi leimaamisesta, syyttömänä vangitsemisesta, lavastamisesta, etsintäkuulutuksista, kotietsinnöistä, salaisista pakkokeinoista, viranomaisvainoista ja niiden taloudellisista ja muista motiiveista. Lisäksi Kavonius kertoo videoilla koronarokotepetoksista ja poliittisesta toiminnastaan. Videoilla on 24.10.2026 mennessä jo lähes 900.000 katselukertaa.</p>
<h3>FACEBOOK</h3>
<p><a target="_blank" rel="noopener" href="https://www.facebook.com/jaana.pedersen.7/">https://www.facebook.com/jaana.pedersen.7/</a></p>
<p>Facebookissa Kavoniuksella on yli 8.600 seuraajia ja hänen Facebook-profiilissaan julkaisemillaan tiedotteilla on satojatuhansia katselukertoja, jopa 500.000 katselukertaa yksittäisellä tiedotteilla.</p>
<h3>RUMBLE</h3>
<p><a target="_blank" rel="noopener" href="https://rumble.com/user/JaanaKavonius?e9s=src_v1_sa%2Csrc_v1_sa_m">https://rumble.com/user/JaanaKavonius?e9s=src_v1_sa%2Csrc_v1_sa_m</a></p>
<p>Rumblesta löydätte Jaanalla on asiaa-ohjelmat, videoita kovilla oikeilla faktoilla koronarokotuksista suomeksi ja englanniksi, Virkamafian raiskauskultti-videon (autenttiseen äänitteeseen perustuva dokumentti), Virkamafia-laulun, Kavoniuksen esittämän Evakonlaulun, Maan korvessa-laulun, 63-osaisen Totuussoturi-videosarjan ja paljon muuta. Videot ja laulut löytyvät myös virkamafia.fi-sivulta.</p>
<h3>YOUTUBE</h3>
<p><a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UCow7RgWLIX4gU2NgtK2gzOA">https://www.youtube.com/channel/UCow7RgWLIX4gU2NgtK2gzOA</a></p>
<p>Youtubessa ”Jaana Kavonius Vapaaksi Vangittu”-kanavalla ovat TikTok-videot JAKSOT 1-10 englanniksi tekstitettyinä ja osa Totuussoturi-sarjan videoista. Lisää englanninkielistä materiaalia ladataan myöhemmin Youtubeen ja muille kanaville.</p>
<h3>MV-LEHTI</h3>
<p><a target="_blank" rel="noopener" href="https://mvlehti.net/2015/09/19/lakimies-suomen-tyhmin-hallitus-toteuttaa-suomen-islamisaatiota-ja-miehitysta/">https://mvlehti.net/2015/09/19/lakimies-suomen-tyhmin-hallitus-toteuttaa-suomen-islamisaatiota-ja-miehitysta/</a></p>
<p>MV-lehti julkaisi 19.9.2015 Kavoniuksen maahanmuuttoa ja Soinin, Sipilän ja Subbin typerää vahingollista politiikkaa ja hallitusta koskevan kirjoituksen. Kirjoitusta luettiin parissa viikossa 60.000 kertaa. Joku teki nimettömän rikosilmoituksen ja väitti tekstiä kiihottamisrikokseksi. Valtakunnansyyttäjä Raija Toiviainen teki kuitenkin 20.6.2017 asiassa syyttämättäjättämispäätöksen (päätös 17/465, asianumero E 17/351) ja totesi kirjoituksen olevan kaikilta osin hyväksyttävää sananvapauden käyttöä yhteiskunnallisesti merkittävässä asiassa ja poliittisen mielipiteen ilmaus. Toiviainen teki päätöksensä nimenomaan ”ei rikosta”-perusteella ja totesi, että kirjoitus ei ole rikos. Päätös on luettavissa virkamafia.fi-sivulla kokonaisuudessaan.</p>
<p>Kavoniukseen 27.3.2023 lukien kohdistetut lavastetut syytteet ovat hyökkäys sananvapautta kohtaan, lavastukset on toteutettu sopimalla lavastajien kesken koko todistelun estämisestä (syyttömyysnäytön estäminen) ja lavastuksia toteuttavat ne, joiden rikollisuuden Kavonius paljasti oikeilla todisteilla. Lavastajat eivät ole soveltaneet mitään lakeja eivätkä Toiviaisen päätöksessä mainittua ihmisoikeussopimuksen ja EIT:n (ihmisoikeustuomioistuimen) laillista sananvapauden tulkintaa.</p>
<h3>VIDEO KORONAROKOTUKSIA KOSKEVAN RIKOSILMOITUKSEN VIREILLETULOSTA KRP:LLE</h3>
<p><a target="_blank" rel="noopener" href="https://www.youtube.com/watch?v=Fy2ZA0cNDcw">https://www.youtube.com/watch?v=Fy2ZA0cNDcw</a></p>
<p>Kavonius on 20.1.2022 vienyt henkilökohtaisesti koronarokotuksia koskevan laajan rikosilmoituksen KRP:lle. Sen vieminen on dokumentoitu/ videoitu. Rikosilmoituksen teksti ja noin 300 muuta rikosilmoitusta virkamafiarikoksista, koronarokotuksista, lavastuksista ja petoksista löydätte virkamafia.fi-sivulta.</p>
<h3>MUUT KANAVAT</h3>
<p>Kavoniuksella on paljon aiempaa materiaalia myös Telegramissa, Instagramissa ja VK:ssa.</p>
<p>Lisäksi netissä on valtava määrä Kavoniuksen haastatteluja ja puheita</p>
<ul><li>Mikko Kemppen ohjelmissa</li><li>Leveli-podcastissa</li><li>Reformistudion haastatteluina</li><li>Totuus voittaa-ohjelmissa toimittaja Tiina Keskimäen kanssa</li><li>Totuudenetsijät-kanavalta ja Anne ja Mikko Vapan tuottamissa ohjelmissa</li><li>Teemu Vehkalan haastatteluissa</li><li>T-Talk-kanavan haastatteluissa</li><li>videoita Convoysta ja muista kymmenistä mielenosoituksista, joissa Kavonius on toiminut puhujana</li><li>videoita kiertueilta (Instagramissa)</li><li>videoita ja Reformistudion livestriimauksina hänen nälkälakostaan 31.10-7.11.2021 Helsingin Kauppatorilla</li></ul>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>

  <script>
    export default {
      name: 'LinkitKavoniuksenJulkaisuihin',
      metaInfo: {
        title: 'Linkit Kavoniuksen julkaisuihin',
      }
    }
  </script>

  <style scoped>
  p {
    margin-top: 1rem;
  }
  h1 {
      margin-top: 1rem;
      font-size: 1.8rem;
      font-weight: bold;
  }
  h2 {
      margin-top: 1rem;
      font-size: 1.5rem;
      font-weight: bold;
  }
  h3 {
      margin-top: 1rem;
      font-size: 1.2rem;
      font-weight: bold;
  }
  .linkit h3 {
    margin-top: 2rem;
  }
  .linkit p {
    margin-top: 0.5rem;
  }
  .linkit a {
    word-break: break-all;
  }
  .linkit ul {
    list-style: disc;
    margin: 0.5rem 0 0 2rem;
  }
  #parallax-1 {
  
    background: url(../assets/1_elegant_BW_spotlight_background.jpg);
  
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  
  </style>